
export default function AESErrorPage() {
    return (
        <div id="error-page" className="d-flex flex-column align-items-center">
            <h1>404</h1>
            <div>Seite nicht gefunden</div>
            <div>Page not found</div>
        </div>
    );
}